import { BackendError } from '../../requests'
import { scopedIntlType } from './DatacMessage'

export const getErrorMessage = (code: BackendError | 403 | 429, intl: scopedIntlType) => {
  switch (code) {
    case 403:
      return intl('error.executing_request.forbidden_description')
    case 429:
      return 'Too many requests'
    case BackendError.USER_INVITATION_NOT_EXISTS:
      return 'Invitation not exists'
    case BackendError.USER_NOT_EXISTS:
      return 'User not exists'
    case BackendError.USER_BAD_ACTIVATION_TOKEN:
      return 'Bad activation token'
    case BackendError.USER_BAD_USER_ID:
      return 'Bad user ID'
    case BackendError.USER_PASSWORD_RESET_TOKEN_NOT_EXISTS:
      return 'Password reset token not exists'
    case BackendError.USER_PASSWORD_RESET_TOKEN_EXPIRED:
      return 'Password reset token expired'
    case BackendError.USER_PASSWORD_TOO_COMMON:
      return 'Password too common'
    case BackendError.USER_PASSWORD_TOO_SIMILAR:
      return 'Password too similar'
    case BackendError.USER_PASSWORD_NEW_SAME_AS_OLD:
      return 'New password same as old'
    case BackendError.USER_WRONG_INVITATION_EMAIL:
      return 'Wrong invitation email'
    case BackendError.USER_DOES_NOT_BELONG_TO_STUDY:
      return 'User does not belong to study'
    case BackendError.USER_PASSWORD_WRONG:
      return 'Password wrong'
    case BackendError.USER_TEMPORARILY_BLOCKED:
      return 'User temporarily blocked'
    case BackendError.USER_INVITATION_ALREADY_EXISTS:
      return 'Invitation already exists'
    case BackendError.USER_BAD_ROLE:
      return 'Bad user role'
    case BackendError.USER_LAST_ADMIN_CANNOT_CHANGE_ROLE:
      return 'Last admin cannot change role'
    case BackendError.USER_LAST_ADMIN_CANNOT_DELETE:
      return 'Cannot delete last admin'
    case BackendError.USER_INVALID_EMAIL_FORMAT:
      return 'Invalid email format'
    case BackendError.USER_EPHEMERAL_CODE_INVALID:
      return 'Invalid ephemeral code'
    case BackendError.USER_MFA_CODE_INVALID:
      return 'Invalid MFA code'
    case BackendError.USER_WITH_THAT_EMAIL_EXISTS:
      return 'User with that email exists'
    case BackendError.USER_IS_EXCLUDED_FROM_SECTION_OR_SUBSECTION:
      return 'User is excluded from section or subsection'
    case BackendError.USER_WRONG_LOGIN_TYPE:
      return 'Wrong login type'
    case BackendError.USER_NEW_EMAIL_SAME_AS_OLD:
      return 'New email same as old'
    case BackendError.USER_IS_NOT_SUBJECT:
      return 'User is not subject'
    case BackendError.USER_ONLY_ADMIN_CAN_CHANGE_ADMIN:
      return 'Only admin can change admin'
    case BackendError.USER_STUDY_INVITATION_ALREADY_EXISTS:
      return 'Study invitation already exists'
    case BackendError.USER_OR_INVITATION_IDS_SHOULD_BE_SENT:
      return 'User or invitation IDs should be sent'
    case BackendError.STUDY_NOT_EXISTS:
      return 'Study not exists'
    case BackendError.STUDY_REFERENCE_ALREADY_EXISTS:
      return 'Study reference already exists'
    case BackendError.STUDY_REFERENCE_WRONG_FORMAT:
      return 'Study reference in wrong format'
    case BackendError.STUDY_CANNOT_UPDATE_ADMIN:
      return 'Cannot remove admin'
    case BackendError.STUDY_STATUS_ILLEGAL_TRANSITION:
      return 'Illegal status transition'
    case BackendError.STUDY_STATUS_SUSPENDED:
      return 'Study status suspended'
    case BackendError.STUDY_STATUS_ENDED:
      return 'Study status ended'
    case BackendError.STUDY_DOCUMENTS_LIMIT_REACHED:
      return 'Documents limit reached'
    case BackendError.STUDY_DOCUMENT_NOT_EXISTS:
      return 'Document not exists'
    case BackendError.STUDY_DOCUMENT_OWNED_BY_ANOTHER_USER:
      return 'Document owned by another user'
    case BackendError.STUDY_CENTER_ABBREVIATION_WRONG_FORMAT:
      return 'Center abbreviation in wrong format'
    case BackendError.STUDY_CENTER_ABBREVIATION_ALREADY_EXISTS:
      return 'Center abbreviation already exists'
    case BackendError.STUDY_CENTERS_LIMIT_REACHED:
      return 'Centers limit reached'
    case BackendError.STUDY_CENTER_NOT_IN_STUDY:
      return 'Center not in study'
    case BackendError.STUDY_CENTER_NOT_EXISTS:
      return 'Center not exists'
    case BackendError.STUDY_MISSING_ENDED_TO_LIVE_REASON:
      return 'Missing ended to live reason'
    case BackendError.STUDY_RANDOMISATION_DISTANCE_METHOD_REQUIRED:
      return 'Study randomisation distance method required'
    case BackendError.STUDY_RANDOMISATION_METHOD_REQUIRED:
      return 'Study randomisation method required'
    case BackendError.STUDY_CENTER_CANT_ADD_ARCHIVED:
      return 'Study center cant add archived'
    case BackendError.STUDY_RANDOMISATION_ALLOCATION_ERROR:
      return 'The allocation is not existing or not available, please contact your administrator for assistance'
    case BackendError.STUDY_CENTER_CANT_DELETE_LAST:
      return 'Cannot delete last center'
    case BackendError.STUDY_CENTER_CANT_DELETE_USED:
      return 'Cant delete used center'
    case BackendError.STUDY_STATUS_NOT_LIVE:
      return 'Study status not live'
    case BackendError.STUDY_STATUS_ARCHIVED:
      return 'Study status archived'
    case BackendError.STUDY_STATUS_NOT_DRAFT:
      return 'Study status not draft'
    case BackendError.STUDY_SUBJECT_ALREADY_RANDOMISED:
      return 'Subject already randomised'
    case BackendError.STUDY_NO_RANDOMISATION:
      return 'No randomisation'
    case BackendError.STUDY_USER_EXISTS:
      return 'User exists'
    case BackendError.STUDY_STATUS_LIVE:
      return 'Study status live'
    case BackendError.STUDY_RANDOMISATION_EXISTS:
      return 'Study randomisation exists'
    case BackendError.STUDY_UUID_HEADER_MISSING:
      return 'UUID Header missing'
    case BackendError.STUDY_WRONG_SUBJECT_ID_PATTERN:
      return 'Wrong subject id pattern'
    case BackendError.STUDY_WRONG_SUBJECT_ID_TYPE:
      return 'Wrong subject id type'
    case BackendError.ECRF_ALREADY_EXISTS:
      return 'Ecrf already exists'
    case BackendError.ECRF_NOT_EXISTS:
      return 'Ecrf not exists'
    case BackendError.ECRF_SECTION_NOT_EXISTS:
      return 'Section not exists'
    case BackendError.SUBSECTION_NOT_EXISTS:
      return 'Subsection not exists'
    case BackendError.ECRF_QUESTION_NOT_EXISTS:
      return 'Question not exists'
    case BackendError.ECRF_QUESTION_VARIABLE_NOT_UNIQUE:
      return 'Question variable not unique'
    case BackendError.ECRF_QUESTION_VARIABLE_BAD_FORMAT:
      return 'Question variable in bad format'
    case BackendError.ECRF_QUESTION_LIMIT_REACHED:
      return 'Question limit reached'
    case BackendError.ECRF_SECTION_LIMIT_REACHED:
      return 'Section limit reached'
    case BackendError.ECRF_QUESTION_OPTION_NOT_EXISTS:
      return 'Question option not exists'
    case BackendError.ECRF_CANNOT_EDIT_LIVE_STUDY_ECRF:
      return 'Cannot edit live study'
    case BackendError.ECRF_SUBSECTION_LIMIT_REACHED:
      return 'Subsection limit reached'
    case BackendError.ECRF_FILE_NO_EXISTS:
      return 'File not exists'
    case BackendError.ECRF_STATIC_CONTENT_LIMIT_REACHED:
      return 'Static content limit reached'
    case BackendError.ECRF_CANNOT_EDIT_EXCLUDED_INCLUSION:
      return 'Cannot edit excluded inclusion'
    case BackendError.ECRF_STATIC_CONTENT_IMAGE_NOT_FOUND:
      return 'Static content image not found'
    case BackendError.ECRF_QUESTION_CANNOT_BE_REQUIRED:
      return 'Question cannot be required'
    case BackendError.ECRF_QUESTION_INVALID_OPERATOR_ARGS:
      return 'Question invalid operator args'
    case BackendError.ECRF_QUESTION_INVALID_DATETIME_SUBTYPE:
      return 'Question invalid datetime subtype'
    case BackendError.ECRF_QUESTION_INVALID_TYPE:
      return 'Question invalid type'
    case BackendError.ECRF_REPEATED_MEASURE_LIMIT_REACHED:
      return 'Repeated measure limit reached'
    case BackendError.ECRF_BLOCKS_IN_REPEATED_MEASURE_LIMIT_REACHED:
      return 'Blocks in repeated measure limit reached'
    case BackendError.ECRF_QUESTION_CONFIG_MAX_NOT_GREATER_THAN_MIN:
      return 'Question config max not greater than min'
    case BackendError.ECRF_QUESTION_CONFIG_TOO_FEW_OPTIONS:
      return 'Question config too few options'
    case BackendError.ECRF_QUESTION_VARIABLE_NOT_EXISTS:
      return 'Question variable not exists'
    case BackendError.ECRF_BUTTON_CONTENT_LIMIT_REACHED:
      return 'Button content limit reached'
    case BackendError.ECRF_BUTTON_CONTENT_NOT_FOUND:
      return 'Button content not found'
    case BackendError.ECRF_QUESTION_USED_IN_STRATIFICATION:
      return 'Question used in stratification'
    case BackendError.ECRF_SECTION_HIDDEN:
      return 'Subsection hidden'
    case BackendError.ECRF_SUBSECTION_LOCKED:
      return 'Subsection locked'
    case BackendError.ECRF_DATA_VALIDATION_LIMIT_REACHED:
      return 'Data validation limit reached'
    case BackendError.ECRF_ROW_ALREADY_ANSWERED:
      return 'Row already answered'
    case BackendError.ANSWER_BAD_SELECTIONS:
      return 'Bad selections'
    case BackendError.ANSWER_BAD_DATETIME_FORMAT:
      return 'Bad datetime format'
    case BackendError.ANSWER_NOT_EXISTS:
      return 'Answer not exists'
    case BackendError.ANSWER_FOR_INVALID_QUESTION_TYPE:
      return 'Answer for invalid question type'
    case BackendError.ANSWER_INVALID_VALUE:
      return 'Invalid value'
    case BackendError.ANSWER_IS_PREFILLED:
      return 'Answer is prefilled'
    case BackendError.ANSWER_TOO_MANY_CHARACTERS:
      return 'Too many characters'
    case BackendError.TEMPLATE_TITLE_ALREADY_EXISTS:
      return 'Template title already exists'
    case BackendError.TEMPLATE_NOT_EXISTS:
      return 'Template not exists'
    case BackendError.TEMPLATE_DUPLICATED_SECTIONS_IDS:
      return 'Duplicated sections IDs'
    case BackendError.TEMPLATE_DUPLICATED_SUBSECTIONS_IDS:
      return 'Duplicated subsections IDs'
    case BackendError.TEMPLATE_WRONG_PARAMS:
      return 'Wrong params'
    case BackendError.TEMPLATE_DUPLICATED_BLOCKS_IDS:
      return 'Duplicated blocks IDs'
    case BackendError.TEMPLATE_INVALID_STRUCTURE:
      return 'Invalid structure'
    case BackendError.INCLUSION_NOT_EXISTS:
      return 'Inclusion not exists'
    case BackendError.INCLUSION_ALREADY_EXISTS:
      return 'Inclusion already exists'
    case BackendError.SUBJECT_NOT_EXISTS:
      return 'Subject not exists'
    case BackendError.SUBJECT_ALREADY_EXISTS:
      return 'Subject already exists'
    case BackendError.SUBJECT_BAD_FORMAT:
      return 'Subject bad format'
    case BackendError.SUBJECT_ALREADY_IN_THE_STUDY:
      return 'Subject already in the study'
    case BackendError.SUBJECT_NOT_IN_THE_STUDY:
      return 'Subject not in the study'
    case BackendError.SUBJECT_EMAIL_ALREADY_TAKEN:
      return 'Subject email already taken'
    case BackendError.SUBJECT_CANT_EDIT_EMAIL:
      return 'Cant edit email'
    case BackendError.SUBJECT_NOT_CONSENTED:
      return 'Subject not consented'
    case BackendError.SUBJECT_CANT_BE_DELETED:
      return 'Subject cant be deleted'
    case BackendError.SUBJECT_CANT_ASSIGN_TO_STRATUM:
      return 'Cant assign to stratum'
    case BackendError.SUBJECT_ID_NOT_UNIQUE:
      return 'Subject ID not unique'
    case BackendError.SUBJECT_SHARING_FORBIDDEN:
      return 'Subject sharing is forbidden'
    case BackendError.SUBJECT_NOT_AVAILABLE:
      return 'Subject not available'
    case BackendError.SUBJECT_CONSENT_MAX_LIMIT:
      return 'Subject consent max limit'
    case BackendError.EXPORT_NO_INCLUSIONS:
      return 'No inclusions'
    case BackendError.EXPORT_PDF_INCLUSION_ID_NOT_PROVIDED:
      return 'Inclusion ID not provided'
    case BackendError.EXPORT_PDF_TYPE_NOT_ALLOWED:
      return 'Type not allowed'
    case BackendError.EXPORT_PDF_STUDY_ID_NOT_PROVIDED:
      return 'Study ID not provided'
    case BackendError.EXPORT_PDF_EXPORTING_UPLOADED_FILES_NOT_ALLOWED:
      return 'Exporting uploaded files not allowed'
    case BackendError.UPLOADED_FILE_RELATED_OBJECT_NOT_EXISTS:
      return 'Related object not exists'
    case BackendError.UPLOADED_FILE_FILES_PER_OBJECT_LIMIT_REACHED:
      return 'Files per object limit reached'
    case BackendError.UPLOADED_FILE_SIZE_LIMIT_EXCEEDED:
      return 'File size limit exceeded'
    case BackendError.ECRF_NOT_ALL_REQUIRED_QUESTIONS_ANSWERED:
      return 'Not all required questions answered'
    case BackendError.ECRF_INVALID_FILTER_OPERATOR:
      return 'Invalid filter operator'
    case BackendError.UPLOADED_FILE_QUESTION_NOT_EXISTS:
      return 'Question not exists'
    case BackendError.UPLOADED_FILE_INCLUSION_NOT_EXISTS:
      return 'Inclusion not exists'
    case BackendError.UPLOADED_FILE_INCLUSION_AND_QUESTION_IN_DIFFERENT_STUDIES:
      return 'Inclusion and question in different studies'
    case BackendError.UPLOADED_FILE_INVALID_FORMAT:
      return 'Invalid format'
    case BackendError.UPLOADED_FILE_INVALID_IMG_FORMAT:
      return 'Invalid image format'
    case BackendError.UPLOADED_FILE_ENCODING_NOT_DETECTED:
      return 'Uploaded file encoding not detected'
    case BackendError.QUERY_ALREADY_EXISTS:
      return 'Query already exists'
    case BackendError.QUERY_BAD_STATUS_TRANSITION:
      return 'Bad query status transition'
    case BackendError.QUERY_WRONG_PARAMS:
      return 'Wrong query params'
    case BackendError.QUERY_REPLIES_LIMIT_REACHED:
      return 'Query replies limit reached'
    case BackendError.QUERY_NOT_EXISTS:
      return 'Query not exists'
    case BackendError.QUERY_STATUS_CLOSED:
      return 'Query status closed'
    case BackendError.CONDITIONAL_LOGIC_BAD_QUESTION_TYPE:
      return 'Conditional logic bad question type'
    case BackendError.CONDITIONAL_LOGIC_SELF_REFERENCE_ERROR:
      return 'Conditional logic self reference error'
    case BackendError.CONDITIONAL_LOGIC_BAD_OPTION:
      return 'Conditional logic bad option'
    case BackendError.CONDITIONAL_LOGIC_BAD_JOIN_OPERATOR:
      return 'Conditional logic bad join operator'
    case BackendError.CONDITIONAL_LOGIC_MISSING_REFERENCE:
      return 'Conditional logic is missing reference'
    case BackendError.CONDITIONAL_LOGIC_TYPE_CHANGE_NOT_ALLOWED:
      return 'Conditional logic type change not allowed'
    case BackendError.SIGNATURE_WRONG_SECTION_IDS:
      return 'Wrong section IDs'
    case BackendError.SIGNATURE_CANNOT_SIGN_SECTION:
      return 'Cannot sign section'
    case BackendError.SIGNATURE_CANNOT_UNSIGN_SECTION:
      return 'Cannot unsign section'
    case BackendError.SIGNATURE_SECTION_ALREADY_SIGNED:
      return 'Section already signed'
    case BackendError.CALCUL_EMPTY_FORMULA:
      return 'Calcul empty formula'
    case BackendError.CALCUL_INCORRECT_FORMULA_FORMAT:
      return 'Calcul incorrect formula format'
    case BackendError.CALCUL_EMPTY_VARIABLES_IN_FORMULA:
      return 'Calcul empty variables in formula'
    case BackendError.CALCUL_VARIABLE_MISMATCH:
      return 'Calcul variables mismatch'
    case BackendError.CALCUL_VARIABLE_NO_ANSWER:
      return 'Calcul variable no answer'
    case BackendError.CALCUL_INCORRECT_ANSWER_FORMAT_FOR_VARIABLE:
      return 'Calcul incorrect answer format for variable'
    case BackendError.CALCUL_ANSWER_IS_NOT_NUMBER_TYPE:
      return 'Calcul answer is not number type'
    case BackendError.CALCUL_INCORRECT_COMPILED_FORMULA_FORMAT:
      return 'Calcul incorrect compiled formula format'
    case BackendError.CALCUL_ERROR_IN_EVALUATION:
      return 'Calcul error in evaluation'
    case BackendError.CALCUL_RESULT_NOT_NUMBER:
      return 'Calcul result not number'
    case BackendError.CALCUL_NUMBER_TOO_BIG:
      return 'Calcul number too big'
    case BackendError.CALCUL_INVALID_SUBTYPE:
      return 'Calcul invalid subtype'
    case BackendError.CALCUL_INVALID_REFERENCE_QUESTION:
      return 'Calcul invalid reference question'
    case BackendError.CALCUL_INVALID_DATE_PERIOD_TYPE:
      return 'Calcul invalid date period type'
    case BackendError.CALCUL_MISSING_DATE_PERIOD_AMOUNT:
      return 'Calcul missing date period amount'
    case BackendError.CALCUL_REFERENCE_NO_ANSWER:
      return 'Calcul reference no answer'
    case BackendError.CALCUL_AGE_INVALID_QUESTION_SUBTYPE:
      return 'Calcul age invalid question subtype'
    case BackendError.CALCUL_AS_BLOCK_TEMPLATE_NOT_ALLOWED:
      return 'Calcul as block template not allowed'
    case BackendError.CALCUL_INVALID_SYSTEM_VARIABLE:
      return 'Invalid system variable'
    case BackendError.CALCUL_MULTIPLE_SYSTEM_VARIABLES_NOT_SUPPORTED:
      return 'Multiple system variables not supported'
    case BackendError.REPEATED_MEASURE_BAD_BLOCK:
      return 'Bad block'
    case BackendError.REPEATED_MEASURE_NOT_FOUND:
      return 'Repeated measure not found'
    case BackendError.REPEATED_MEASURE_SINGLE_MEASURE_LIMIT_REACHED:
      return 'Single measure limit reached'
    case BackendError.REPEATED_MEASURE_QUESTION_TYPE_NOT_ALLOWED:
      return 'Question type not allowed'
    case BackendError.REPEATED_MEASURE_QUESTION_TYPES_NOT_DEFINED:
      return 'Question types not defined'
    case BackendError.EPRO_NOT_EXISTS:
      return 'Epro not exists'
    case BackendError.EPRO_FORM_ALREADY_EXISTS:
      return 'Epro form already exists'
    case BackendError.EPRO_FORM_NOT_EXISTS:
      return 'Epro form not exists'
    case BackendError.EPRO_MODULE_FORBIDDEN:
      return 'Epro module forbidden'
    case BackendError.EPRO_RECORD_NOT_EXISTS:
      return 'Epro record not exists'
    case BackendError.EPRO_STATUS_TRANSITION_NOT_ALLOWED:
      return 'Epro status transition not allowed'
    case BackendError.EPRO_STATUS_PUBLISHED:
      return 'Epro status published'
    case BackendError.EPRO_QUESTION_NOT_EXISTS:
      return 'Epro question not exists'
    case BackendError.EPRO_STATUS_ENDED:
      return 'Epro status ended'
    case BackendError.EPRO_INVALID_TARGET_DATE:
      return 'Invalid target date'
    case BackendError.EPRO_REMINDER_INVALID_DATE:
      return 'Reminder invalid date'
    case BackendError.EPRO_REMINDER_NO_TARGET_DATE:
      return 'No target date'
    case BackendError.EPRO_REMINDER_MAX_AMOUNT_EXCEEDED:
      return 'Epro reminder max amount exceeded'
    case BackendError.EPRO_STATUS_ARCHIVED:
      return 'Epro status archived'
    case BackendError.EPRO_QR_ON:
      return 'Epro QR is on'
    case BackendError.EPRO_QR_OFF:
      return 'Epro QR is off'
    case BackendError.EPRO_QR_EMAIL_REQUIRED:
      return 'Email required for Epro from QR'
    case BackendError.EPRO_SUBJECT_HAS_OTHER_CENTER:
      return 'Subject has other center'
    case BackendError.EPRO_RECORD_EXISTS:
      return 'Epro record exists'
    case BackendError.REMINDER_QUESTIONS_REFERENCE_NOT_EXIST:
      return 'Reference not exists'
    case BackendError.REMINDER_QUESTIONS_LIMIT_REACHED:
      return 'Reminder question limit reached'
    case BackendError.ECONSULT_VIDEO_DOES_NOT_EXIST:
      return 'Video does not exist'
    case BackendError.ECONSULT_MODULE_FORBIDDEN:
      return 'Econsult module forbidden'
    case BackendError.ECONSULT_SUBJECT_STUDY_DOES_NOT_EXIST:
      return 'Subject study does not exist'
    case BackendError.ANALYTICS_TABLE_LIMIT_REACHED:
      return 'Analytics table limit reached'
    case BackendError.ANALYTICS_ENTITY_NOT_EXIST:
      return 'Entity not exist'
    case BackendError.ANALYTICS_CHART_LIMIT_REACHED:
      return 'Chart limit reached'
    case BackendError.ANALYTICS_CHART_NOT_FOUND:
      return 'Chart not found'
    case BackendError.ANALYTICS_QUESTIONS_DIFFERENT_DOCUMENTS:
      return 'Questions from different documents'
    case BackendError.REVIEW_SUBSECTION_ALREADY_REVIEWED_BY_USER:
      return 'Subsection already reviewed by user'
    case BackendError.REVIEW_ALREADY_UNREVIEWED:
      return 'Review already unreviewed'
    case BackendError.REVIEW_WRONG_USER_TO_UNREVIEW:
      return 'Wrong user to unreview'
    case BackendError.REVIEWS_DISABLED:
      return 'Reviews disabled'
    case BackendError.ECONSENT_ALREADY_EXISTS:
      return 'Econsent already exists'
    case BackendError.ECONSENT_NOT_EXISTS:
      return 'Econsent not exists'
    case BackendError.ECONSENT_MODULE_FORBIDDEN:
      return 'Econsent module forbidden'
    case BackendError.ECONSENT_RECORD_NOT_EXISTS:
      return 'Econsent record not exists'
    case BackendError.ECONSENT_QUESTION_NOT_EXISTS:
      return 'Question not exists'
    case BackendError.ECONSENT_RECORD_WRONG_STATUS:
      return 'Record wrong status'
    case BackendError.ECONSENT_SECTION_WRONG_SIGNATURE:
      return 'Section wrong signature'
    case BackendError.ECONSENT_FULFILLMENT_PENDING:
      return 'Fulfillment pending'
    case BackendError.ECONSENT_SIGNATURE_WRONG_FORMAT:
      return 'Signature wrong format'
    case BackendError.ECONSENT_WRONG_SUBJECT:
      return 'Wrong subject'
    case BackendError.ECONSENT_ESIGNATURE_FAILED:
      return 'Esignature failed'
    case BackendError.ECONSENT_ESIGNATURE_OFF:
      return 'Esignature off'
    case BackendError.ECONSENT_ESIGNATURE_ON:
      return 'Esignature on'
    case BackendError.ECONSENT_QR_CODE_NOT_FOUND:
      return 'Esignature QR code not found'
    case BackendError.ECONSENT_QR_CODE_FOUND:
      return 'Esignature Qr code found'
    case BackendError.ECONSENT_ONLY_DRAFT_CAN_BE_PUBLISHED:
      return 'Only draft can be published'
    case BackendError.ECONSENT_ALREADY_ARCHIVED:
      return 'Already archived'
    case BackendError.ECONSENT_NOT_PUBLISHED:
      return 'Not published'
    case BackendError.ROLE_PREDEFINED:
      return 'Role predefined'
    case BackendError.ROLE_NAME_NOT_UNIQUE:
      return 'Role name not unique'
    case BackendError.SUBJECT_ACCOUNT_WRONG_TYPE:
      return 'Wrong account type'
    case BackendError.INVITATION_MISSING_EMAIL:
      return 'Invitation missing email'
    case BackendError.INVITATION_EXPIRED:
      return 'Invitation expired'
    case BackendError.DATA_ANALYSIS_INVALID_FILE_CONTENT:
      return 'Invalid file content'
    case BackendError.FOLDER_NOT_EMPTY:
      return 'Folder not empty'
    case BackendError.FOLDER_TOO_NESTED:
      return 'Folder too nested'
    case BackendError.SUBJECT_REPOSITORY_MODULE_FORBIDDEN:
      return 'Subject repository module forbidden'
    case BackendError.SUBJECT_REPOSITORY_IMPORT_UUID_MISSING:
      return 'Subject repository import uuid missing'
    case BackendError.SUBJECT_REPOSITORY_WRONG_STATUS:
      return 'Subject repository wrong status'
    case BackendError.SUBJECT_REPOSITORY_VARIABLE_FORBIDDEN:
      return 'Subject repository variable forbidden'
    case BackendError.SUBJECT_REPOSITORY_INVALID_STATUS_TRANSITION:
      return 'Subject repository invalid status transition'
    case BackendError.SUBJECT_REPOSITORY_SUBJECT_FORBIDDEN:
      return 'Subject repository subject forbidden'
    case BackendError.SDV_MEASURE_REQUIRED:
      return 'SDV measure required'
    case BackendError.API_NOT_ENABLED:
      return 'API not enabled'
    case BackendError.RECRUITMENT_USER_DOES_NOT_BELONG_TO_STUDY:
      return 'User does not belong to study'
    case BackendError.RECRUITMENT_MODULE_FORBIDDEN:
      return 'Module forbidden'
    case BackendError.RECRUITMENT_RECORD_STATUS_ILLEGAL_TRANSITION:
      return 'Record status illegal transition'
    case BackendError.RECRUITMENT_TOKEN_REQUIRED:
      return 'Token required'
    case BackendError.RECRUITMENT_STUDY_INACTIVE:
      return 'Study inactive'
    case BackendError.RECRUITMENT_STUDY_NOT_EXISTS:
      return 'Study not exists'
    case BackendError.RECRUITMENT_RECORD_NOT_EXISTS:
      return 'Record not exists'
    case BackendError.RECRUITMENT_PAYMENT_AMOUNT_REQUIRED:
      return 'Payment amount is required'
    case BackendError.RECRUITMENT_ONGOING_PAYMENT_CONFIG_DISABLED:
      return 'Payment settings can\'t be changed if an appointment schedule is already created or if the study is "Recruiting".'
    case BackendError.RECRUITMENT_DISQUALIFIED_CAUSE_REQUIRED:
      return 'Disqualified cause required'
    case BackendError.RECRUITMENT_RECORD_HAS_PAYMENTS_OR_VISITS_OR_WRONG_STATUS:
      return 'Record has payments or visits or wrong status'
    case BackendError.PAYMENT_STATUS_ILLEGAL_TRANSITION:
      return 'Payment status illegal transition'
    case BackendError.CALENDAR_MODULE_FORBIDDEN:
      return 'Calendar module forbidden'
    case BackendError.CALENDAR_CAPACITY_EXCEEDED:
      return 'Capacity exceeded'
    case BackendError.CALENDAR_INVALID_TIME_START_AFTER_END:
      return 'Invalid time start after end'
    case BackendError.CALENDAR_INVALID_TIME_START_IN_THE_PAST:
      return 'Invalid time start in the past'
    case BackendError.CALENDAR_NO_CENTER_ACCESS:
      return 'No center access'
    case BackendError.CALENDAR_SCHEDULE_BOOKING_TYPE_REQUIRED:
      return 'Schedule booking type required'
    case BackendError.CALENDAR_AVAILABILITY_OVERLAP:
      return 'Availability overlap'
    case BackendError.CALENDAR_VISIT_ORDER_REQUIRED:
      return 'Visit order required'
    case BackendError.CALENDAR_EVENT_CAPACITY_EXCEEDED:
      return 'Event capacity exceeded'
    case BackendError.CALENDAR_EVENT_ALREADY_BOOKED:
      return 'Event already booked'
    case BackendError.CALENDAR_SEQUENTIAL_BOOKING_WRONG_EVENT:
      return 'Wrong event in sequential booking'
    case BackendError.CALENDAR_MISSING_EVENT_FOR_SEQUENTIAL_BOOKING:
      return 'Missing event for sequential booking'
    case BackendError.CALENDAR_APPLICANT_WRONG_STATUS:
      return 'Wrong applicant status'
    case BackendError.CALENDAR_SCHEDULE_NOT_PUBLISHED:
      return 'Schedule is not published'
    case BackendError.CALENDAR_INVALID_DATES:
      return 'Invalid dates'
    case BackendError.CALENDAR_VISIT_SCHEDULE_MANAGEMENT_DISABLED:
      return 'This event is from a scheduler. This action is not possible'
    case BackendError.CALENDAR_SCHEDULER_TOO_FEW_SCHEDULES:
      return 'Scheduler too few schedules'
    case BackendError.CALENDAR_VISIT_CONFIRMATION_MIXED_RECRUITMENT:
      return 'Visit confirmation mixed recruitment'
    case BackendError.CALENDAR_VISIT_NOT_SCHEDULED:
      return 'All visits from the scheduler must have "scheduled" status to allow deletion'
    case BackendError.CALENDAR_SCHEDULER_VISITS_ALREADY_BOOKED:
      return 'Visit already booked'
    case BackendError.PAYMENTS_MODULE_FORBIDDEN:
      return 'Payments module forbidden'
    case BackendError.PRODUCT_DATABASE_DUPLICATE_FORMULA:
      return 'Product already exists'
    case BackendError.SUBJECT_MISSING:
      return 'Subject missing'
    case BackendError.BODY_TOO_LONG:
      return 'Body too long'
    case BackendError.INVITE_TOO_MANY_REQUESTS_FOR_THIS_RECORD:
      return 'Too many requests for this record'
    case BackendError.WRONG_TOKEN_TYPE:
      return 'Token wrong type'
    case BackendError.INVITE_SUBJECT_HAS_NO_EMAIL:
      return 'Subject has no email'
    case BackendError.INVITE_SUBJECT_HAS_NO_PHONE:
      return 'Subject has no phone'
    case BackendError.INVITE_WRONG_SUBJECTS:
      return 'Wrong subjects'
    case BackendError.INVITE_WRONG_PARAMS:
      return 'Wrong invite params'
    case BackendError.DATETIME_MUST_BE_FUTURE:
      return 'Date must be in future'
    case BackendError.DATETIME_CANT_BE_FUTURE:
      return 'Date cant be in future'
    case BackendError.VARIABLE_PREFIX_EXISTS:
      return 'Variable prefix exists'
    case BackendError.VARIABLE_SUFFIX_EXISTS:
      return 'Variable suffix exists'
    case BackendError.EXPORT_ALREADY_EXISTS:
      return 'Export already exists'
    case BackendError.MISSING_FIELDS:
      return 'Missing fields'
    case BackendError.WRONG_RECORD:
      return 'Wrong record'
    case BackendError.WRONG_MODEL:
      return 'Wrong model'
    case BackendError.WRONG_PARAMETER:
      return 'Wrong parameter'
    case BackendError.PAYMENT_CENTER_DATA_MISSING:
      return 'Center account setting are missing'
    case BackendError.PAYMENT_CENTER_MISMATCH:
      return 'Payment orders have different centers'
    case BackendError.PAYMENT_CURRENCY_MISMATCH:
      return 'Payment orders have different currencies'
    case BackendError.PAYMENT_IBAN_INVALID:
      return 'IBAN is invalid'
    case BackendError.PAYMENT_IBAN_WRONG_COUNTRY:
      return 'IBAN Country code is invalid'
    case BackendError.PAYMENT_STATUS_NOT_PROCESSING:
      return 'Payment order status must be Processing'
    case BackendError.PAYMENT_SWIFT_INVALID:
      return 'SWIFT code is invalid'
    case BackendError.PAYMENT_VALIDATION_ERROR:
      return 'Unscpecified payment validation error'
    case BackendError.PAYMENT_STATUS_NOT_PAID:
      return 'Payment order status must be Paid'
    case BackendError.PAYMENT_MISSING_CURRENCY:
      return "You don't have any currency set in your study settings. Please check."
    case BackendError.SIDE_BY_SIDE_ILLEGAL_TRANSITION:
      return 'Side by side illegal transition'
    case BackendError.SIDE_BY_SIDE_PROJECT_NOT_EXISTS:
      return 'Side by side project not exists'
    case BackendError.SIDE_BY_SIDE_SUBJECT_ALREADY_IN_PROJECT:
      return 'Side by side subject already in project'
    case BackendError.SIDE_BY_SIDE_SUBJECT_WRONG_CENTER:
      return 'Side by side subject wrong center'
    case BackendError.SIDE_BY_SIDE_PROJECT_BUILDER_NOT_EDITABLE:
      return 'Side by side project builder not editable'
    case BackendError.SIDE_BY_SIDE_SECTION_NOT_IN_PROJECT:
      return 'Side by side section not in project'
    case BackendError.SIDE_BY_SIDE_USER_DOES_NOT_BELONG_TO_PROJECT:
      return 'Side by side user does not belong to project'
    case BackendError.SIDE_BY_SIDE_TEST_ZONES_EXCEEDED:
      return 'Side by side test zones exceeded'
    case BackendError.SIDE_BY_SIDE_PROJECT_TEST_NOT_EXISTS:
      return 'Side by side project test not exists'
    case BackendError.SIDE_BY_SIDE_PROJECT_TEST_FORMULA_NOT_EXISTS:
      return 'Side by side project test formula not exists'
    case BackendError.PRODUCT_DATABASE_FORMULA_DOES_NOT_EXIST:
      return 'Formula does not exist in library'
    case BackendError.PRODUCT_DATABASE_FORMULA_EDIT_RESTRICTED:
      return 'Formula '
    case BackendError.SUBJECT_ACCOUNT_EXISTS:
      return 'Accounts for some subjects could not be created because the account already exists'
    case BackendError.SUBJECT_EMAIL_REQUIRED:
      return 'Subject email required'
    case BackendError.SUBJECT_NAME_REQUIRED:
      return 'Subject name required'
    case BackendError.STUDY_CENTER_CODE_ALREADY_EXISTS:
      return 'Center with this code already exists'
    case BackendError.STUDY_CENTER_CODE_NOT_ALLOW_TO_MODIFY:
      return 'Center code cannot be changed if there are subjects included'
    case BackendError.RECORD_ALREADY_EXISTS:
      return 'Record already exists'
    case BackendError.MULTIPLE_EXCLUSIVE_PARAMETERS:
      return 'Multiple exclusive parameters'
    case BackendError.RICH_TEXT_INVALID:
      return 'Rich text invalid'
    case BackendError.BULK_DELETE_DOES_NOT_MATCH_QUANTITY:
      return 'Bulk delete does not match quantity'
    case BackendError.STUDY_STATUS_NEITHER_DRAFT_NOR_LIVE:
      return 'Status neither draft nor live '
    case BackendError.ANSWER_QUESTION_DOES_NOT_BELONG_TO_EDC:
      return 'Question does not belong to EDC'
    case BackendError.SUBJECT_ACCESS_ONLY:
      return 'Subject access only'
    case BackendError.SUBJECT_WITHOUT_ACCOUNT:
      return 'Subject has no account'
    case BackendError.SUBJECT_CANT_DELETE_EMAIL:
      return 'Cannot remove subject email'
    case BackendError.EXPORT_ACCESS_NOT_ALLOWED:
      return 'Access not allowed'
    case BackendError.UPLOADED_FILE_WRONG_RESOURCE_TYPE:
      return 'Wrong resource type'
    case BackendError.CONDITIONAL_LOGIC_BAD_BETWEEN_WRONG_LIST:
      return 'Logic bad between wrong list'
    case BackendError.CONDITIONAL_LOGIC_BAD_BETWEEN_WRONG_ELEMENTS_TYPE:
      return 'Logic bad between wrong list'
    case BackendError.CONDITIONAL_LOGIC_BAD_BETWEEN_WRONG_VALUE_ORDER:
      return 'Logic bad between wrong value order'
    case BackendError.EPRO_OCCURENCES_LIMIT_REACHED:
      return 'Limit reached'
    case BackendError.EPRO_SCHEDULED_IN_FUTURE:
      return 'Scheduled in future'
    case BackendError.EPRO_COPYRIGHT_INVALID:
      return 'Copyright invalid'
    case BackendError.EPRO_EXPORT_NOT_ELIGIBLE_DATA:
      return 'not eligible data'
    case BackendError.CALENDAR_COORDINATOR_NOT_IN_CENTERS:
      return 'Coordinator not in centers'
    case BackendError.CALENDAR_RESERVATION_TIMED_OUT:
      return 'Reservation timed out'
    case BackendError.CALENDAR_SEQUENTIAL_BOOKING_VISIT_CAPACITY_DIFFERENCE:
      return 'Sequential booking visit capacity difference'
    case BackendError.CALENDAR_SEQUENTIAL_BOOKING_VISIT_SLOT_COUNT_DIFFERENCE:
      return 'Sequential booking visit slot count difference'
    case BackendError.CALENDAR_SCHEDULER_EVENTS_CAPACITY_INSUFFICIENT:
      return 'Events capacity insufficient'
    case BackendError.CALENDAR_INVALID_NOT_DONE_CAUSE:
      return 'Invalid not done cause'
    case BackendError.CALENDAR_VISIT_CONFIRMATION_MIXED_SCHEDULES:
      return 'Visit confirmation mixed schedules'
    case BackendError.CALENDAR_VISIT_CONFIRMATION_WRONG_STATUS:
      return 'Calendar visit confirmation wrong status'
    case BackendError.CALENDAR_PAYMENT_NOT_ALLOWED:
      return 'Calendar payment not allowed'
    case BackendError.PAYMENT_COMMENT_REQUIRED:
      return 'Payment comment required'
    case BackendError.PAYEMNT_NOT_ALLOWED_FOR_STATUS:
      return 'Payemnt not allowed for status'
    case BackendError.PAYMENT_AMOUNT_CHANGE_NOT_ALLOWED_FOR_STATUS:
      return 'Payment amount change not allowed for status'
    case BackendError.PAYMENT_NOT_ALLOWED:
      return 'Payment not allowed'
    case BackendError.SIDE_BY_SIDE_PROJECT_TEST_ENDED:
      return 'Test ended'
    case BackendError.SIDE_BY_SIDE_PROJECT_TEST_NOT_FOR_BOOKING_SUBJECT:
      return 'Test not for booking subject'
    case BackendError.SIDE_BY_SIDE_PRODUCT_REQUIRED_FOR_NON_GLOBAL_QUESTION:
      return 'Product required for non global question'
    case BackendError.SIDE_BY_SIDE_FORMULA_NOT_ASSIGNED_TO_TEST:
      return 'Formula not assigned to test'
    case BackendError.SIDE_BY_SIDE_FORMULA_NOT_ASSIGNED_TO_PROJECT:
      return 'Formula not assigned to project'
    case BackendError.PRODUCT_DATABASE_WRONG_SEARCH_FIELD:
      return 'Wrong search field'
    case BackendError.WRONG_OBJECT_ID:
      return 'Wrong object id'
    case BackendError.SUBJECT_HAS_NO_ACCOUNT:
      return 'Subject has no account'
    case BackendError.STUDY_RANDOMISATION_QUESTION_HAS_INVALID_ANSWER_CONFIGURATION:
      return 'Each question must have an answer as an option that is in stratum answers'
    case BackendError.RECRUITMENT_STUDY_ARCHIVED_OR_ENDED:
      return 'This study is not available anymore'
    case BackendError.EMAIL_INVALID_CHARACTERS:
      return `The email address shouldn't have any special characters`

    default:
      // Ensures that all cases are handled
      return assertUnreachable(code, intl)
  }
}

const assertUnreachable = (_value: never, intl: scopedIntlType) => {
  return intl('error.executing_request.description')
}
